var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('span',{staticClass:"text-no-wrap",attrs:{"slot":"activator"},slot:"activator"},[_vm._v(" "+_vm._s(_vm._f("date")(_vm.value,_vm.displayMode, _vm.formatString))+" ")]),_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.value,'utc', 'YYYY/MM/DD HH:mm:ss.SSS Z')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }